import type { FaireProductEntity } from "../../entity_types/product";

export const p_a4b4h87rgb: FaireProductEntity = {
  token: "p_a4b4h87rgb",
  type: "product",
  name: "Lokart Pomegranate Turkish Delight - Soft & Chewy Lokum Candy 400g Bulk Pack",
  brandToken: "b_hms9dn67va",
  brandName: "Aladdin",
  imageUrl:
    "https://cdn.faire.com/fastly/0956209b9ea03d9b67c0d7e64de00f94440d0ca17ddec24cb0dbc86f0ee90c16.jpeg",
  galleryImageUrls: [],
  priceDollars: 13,
  description:
    "Indulge your customers in the exquisite taste of Lokart Pomegranate Turkish Delight, a timeless confectionery offering a delicately sweet and subtly tart flavor with every soft, chewy bite. This authentic Turkish dessert provides a unique sensory experience, perfect for any discerning palate.\n\nEach piece of this premium Lokum is expertly crafted using a traditional recipe, highlighting the vibrant and natural essence of pomegranate flavor. Experience the characteristic soft, melt-in-your-mouth texture that defines high-quality Turkish Delight. This 400g bulk pack ensures ample servings, making it ideal for retail display or professional use.\n\n * An excellent product for wholesale confectionery suppliers and gourmet food distributors seeking authentic imported sweets. \n * Perfect for specialty food retailers and e-commerce businesses looking to expand their premium international candy selection. \n * High-demand bulk purchase option for gift basket companies, hospitality venues, and restaurant dessert menus. \n * Source high-quality Turkish dessert imports to enhance your premium product offerings and attract new clientele. ",
  tags: [],
  msrpDollars: 16.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:03.885Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
